import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { toaster } from "@/utilities/toaster";
import Loader from "../../../components/widgets/loader.vue";
import { AssetModel } from "@/store/models/asset/asset";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { DateFormatConstant } from "@/store/DateFormatConstants";
import AssetTypePropertyComponent from "./components/AssetTypePropertyComponent.vue";
import { Guid } from "guid-typescript";
/**
 * Add Asset Components
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AddAsset = /** @class */ (() => {
    let AddAsset = class AddAsset extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.pageIsLoading = true;
            this.ctaButtons = [{ routeName: "assetManager" }];
            this.title = "Add Asset";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Manager",
                    to: "/assetManager",
                },
                {
                    text: "Add Asset",
                    active: true,
                },
            ];
            this.asset = new AssetModel();
            this.assetTypeId = "";
            this.categoryName = "";
            this.datePickerKey = 0; // Initialize key
        }
        saveAsset() {
            this.validate("newAssetObserver").then((response) => {
                if (response) {
                    this.asset.assetTypeId = this.assetTypeId;
                    this.asset.statusId = Guid.createEmpty().toString();
                    var price = this.asset.price;
                    this.asset.price = Number(price);
                    if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                        this.asset.warrantyStartDateAsString = this.dateFormattedString(this.asset.warrantyStartDate);
                        this.asset.warrantyEndDateAsString = this.dateFormattedString(this.asset.warrantyEndDate);
                        if (this.asset.dateOfPurchase) {
                            this.asset.dateOfPurchaseAsString = this.dateFormattedString(this.asset.dateOfPurchase);
                        }
                    }
                    else {
                        this.asset.warrantyStartDateAsString = this.dateFormatted(this.asset.warrantyStartDate);
                        this.asset.warrantyEndDateAsString = this.dateFormatted(this.asset.warrantyEndDate);
                        if (this.asset.dateOfPurchase) {
                            this.asset.dateOfPurchaseAsString = this.dateFormatted(this.asset.dateOfPurchase);
                        }
                    }
                    AssetMasterModule.SaveAsset(this.asset).then((response) => {
                        if (response) {
                            toaster.ShowSuccess("Asset was created successfully.");
                            this.$router.push({ name: "assetManager" });
                        }
                    });
                }
            });
        }
        cancel() {
            this.$router.push({ name: "assetManager" });
        }
        get category() {
            return this.categoryName;
        }
        changeAssetType(assetTypeId) {
            var assetType = AssetMasterModule.assetsType.filter((x) => x.id == assetTypeId);
            for (var i = 0; i < this.assetCategories.length; i++) {
                var category = this.assetCategories[i];
                var categories = assetType.filter((x) => x.assetCategoryId == category.id.toString());
                if (categories.length > 0) {
                    this.categoryName = category.value;
                }
            }
        }
        calculateEndDate() {
            this.asset.warrantyPeriod = parseInt(this.newNumber);
            if (this.newNumber == "") {
                this.asset.warrantyEndDateAsString = "";
            }
            if (this.asset.warrantyStartDate == null) {
                this.asset.warrantyEndDateAsString = "";
            }
            if (this.asset.warrantyPeriod == null) {
                this.asset.warrantyEndDateAsString = "";
            }
            if (this.asset.warrantyPeriod >= 0) {
                if (this.asset.warrantyStartDate == null) {
                    return;
                }
                this.asset.warrantyEndDate = new Date(this.asset.warrantyStartDate);
                this.asset.warrantyEndDateAsString = new Date(this.asset.warrantyEndDate.setFullYear(this.asset.warrantyStartDate.getFullYear() + this.asset.warrantyPeriod)).toLocaleDateString();
                if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                    this.asset.warrantyEndDateAsString = this.dateFormattedString(this.asset.warrantyEndDate);
                }
                else {
                    this.asset.warrantyEndDateAsString = this.dateFormatted(this.asset.warrantyEndDate);
                }
            }
        }
        calculatePrice() {
            var newnumber = new Number(this.asset.price).toFixed(2);
            this.asset.price = newnumber;
        }
        dateOfPurchaseChange() {
            this.asset.warrantyStartDate = this.asset.dateOfPurchase;
            this.calculateEndDate();
        }
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > new Date(today.getTime());
        }
        disabledEarliestDay(date) {
            return date < this.asset.dateOfPurchase;
        }
        calculateWarrantyDate(date) {
            this.asset.warrantyStartDate = new Date(date);
            if (this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY()) {
                this.asset.warrantyStartDateAsString = this.dateFormattedString(this.asset.warrantyStartDate);
            }
            else {
                this.asset.warrantyStartDateAsString = this.dateFormatted(this.asset.warrantyStartDate);
            }
            this.datePickerKey += 1;
            this.calculateEndDate();
        }
        get assetStatus() {
            return AssetMasterModule.assetStatus;
        }
        get assetProperties() {
            return AssetMasterModule.getAssetProperties;
        }
        get assetControlTypes() {
            return AssetMasterModule.getAssetControlType;
        }
        get assetTypes() {
            return AssetMasterModule.assetsType;
        }
        get assetLocations() {
            return AssetMasterModule.assetLocations;
        }
        get vendors() {
            return AssetMasterModule.vendors;
        }
        get assetCategories() {
            return AssetMasterModule.assetCategory;
        }
        //Lifecycle
        created() {
            AssetMasterModule.GetAssetDefaults().then((response) => {
                if (response) {
                }
            });
            this.pageIsLoading = false;
        }
    };
    AddAsset = __decorate([
        Component({
            name: "AddAsset",
            components: {
                Layout,
                PageHeader,
                Loader,
                AssetTypePropertyComponent,
            },
        })
    ], AddAsset);
    return AddAsset;
})();
export default AddAsset;
